var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGjennomkjoringForbudt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-19.174 -100 419.174 500",
    width: "419.174px",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(0.672757, 0, 0, -0.672757, -500.336131, -123.067454)",
    style: {}
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 393.929 106.284 C 393.929 194.671 341.499 247.536 286.739 302.618 C 253.649 334.779 221.749 368.084 189.789 401.388 C 157.889 368.084 125.939 334.779 92.839 302.618 C 38.139 247.536 -15.201 194.671 -15.201 106.284 C -15.201 79.326 -9.901 52.629 0.389 27.723 C 10.679 2.818 25.759 -19.814 44.769 -38.874 C 63.779 -57.94 86.339 -73.059 111.179 -83.374 C 136.009 -93.695 162.629 -99 189.509 -99 C 216.389 -99 243.009 -93.695 267.849 -83.374 C 292.689 -73.059 315.249 -57.94 334.259 -38.874 C 353.269 -19.814 368.349 2.818 378.629 27.723 C 388.919 52.629 394.209 79.326 394.209 106.284 L 393.929 106.284 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "group-1",
    transform: "matrix(1.827345, 0, 0, -1.806357, -586.909436, 511.63029)",
    style: {}
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "group-2",
    transform: "scale(0.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "group-3",
    transform: "matrix(0.701688, 0, 0, -0.701688, -106.384638, -189.18343)",
    style: {
      transformOrigin: "297.784px 297.784px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-4",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5950.68,2977.84 c 0,1641.85 -1330.99,2972.84 -2972.84,2972.84 C 1335.99,5950.68 5,4619.69 5,2977.84 5,1336 1335.99,5 2977.84,5 4619.69,5 5950.68,1336 5950.68,2977.84",
    style: {
      fill: "#f14824",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5950.68,2977.84 c 0,1641.85 -1330.99,2972.84 -2972.84,2972.84 C 1335.99,5950.68 5,4619.69 5,2977.84 5,1336 1335.99,5 2977.84,5 4619.69,5 5950.68,1336 5950.68,2977.84 Z",
    style: {
      fill: "none",
      stroke: "#f14824",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4417.56,1275.36 1275.35,4417.56 C 526.734,3532.31 581.465,2221.05 1401.25,1401.26 2221.04,581.469 3532.3,526.73 4417.56,1275.36",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4417.56,1275.36 1275.35,4417.56 C 526.734,3532.31 581.465,2221.05 1401.25,1401.26 2221.04,581.469 3532.3,526.73 4417.56,1275.36 Z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4680.33,1538.13 c 748.61,885.25 693.88,2196.51 -125.9,3016.3 -819.8,819.78 -2131.06,874.52 -3016.31,125.89 L 4680.33,1538.13",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4680.33,1538.13 c 748.61,885.25 693.88,2196.51 -125.9,3016.3 -819.8,819.78 -2131.06,874.52 -3016.31,125.89 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3716.64,1976.28 h -236.67 c -5.23,27.54 -16.82,53.49 -33.83,75.76 l -327.2,428.43 c -52.87,69.24 -151.86,82.5 -221.09,29.62 l -418.28,-319.43 c -1.27,27.59 1.09,55.24 7.03,82.22 l -179.55,-66.98 c -56.79,-21.18 -107.31,-56.34 -146.91,-102.22 -40.37,-46.76 -53.98,-110.94 -36.06,-170.07 10.1,-33.34 24.99,-65.03 44.19,-94.12 40.98,3.65 82.28,1.02 122.47,-7.78 l -14.58,-42.98 c -186.25,38.05 -369.99,-75.24 -419.64,-258.74 -49.65,-183.5 51.89,-373.98 231.92,-435.04 180.02,-61.06 376.5,28.34 448.72,204.18 72.23,175.85 -4.67,377.54 -175.65,460.66 l 14.58,42.97 c 118.74,-55.68 203.18,-165.39 226.62,-294.42 19.46,-107.16 112.79,-185.07 221.71,-185.07 h 524.87 c 54.62,-165.8 220.31,-268.53 393.12,-243.75 172.8,24.79 302.93,169.94 308.75,344.43 5.82,174.47 -114.36,327.98 -285.13,364.22 -170.76,36.25 -342.93,-55.23 -408.48,-217.03 h -48.18 c 57.28,161.79 210.28,269.95 381.91,269.95 h 160.56 l -135.2,135.19",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3716.64,1976.28 h -236.67 c -5.23,27.54 -16.82,53.49 -33.83,75.76 l -327.2,428.43 c -52.87,69.24 -151.86,82.5 -221.09,29.62 l -418.28,-319.43 c -1.27,27.59 1.09,55.24 7.03,82.22 l -179.55,-66.98 c -56.79,-21.18 -107.31,-56.34 -146.91,-102.22 -40.37,-46.76 -53.98,-110.94 -36.06,-170.07 10.1,-33.34 24.99,-65.03 44.19,-94.12 40.98,3.65 82.28,1.02 122.47,-7.78 l -14.58,-42.98 c -186.25,38.05 -369.99,-75.24 -419.64,-258.74 -49.65,-183.5 51.89,-373.98 231.92,-435.04 180.02,-61.06 376.5,28.34 448.72,204.18 72.23,175.85 -4.67,377.54 -175.65,460.66 l 14.58,42.97 c 118.74,-55.68 203.18,-165.39 226.62,-294.42 19.46,-107.16 112.79,-185.07 221.71,-185.07 h 524.87 c 54.62,-165.8 220.31,-268.53 393.12,-243.75 172.8,24.79 302.93,169.94 308.75,344.43 5.82,174.47 -114.36,327.98 -285.13,364.22 -170.76,36.25 -342.93,-55.23 -408.48,-217.03 h -48.18 c 57.28,161.79 210.28,269.95 381.91,269.95 h 160.56 z",
    style: {
      fill: "none",
      stroke: "#050301",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2843.66,2849.25 c -64.59,-26.2 -112.11,-82.59 -126.96,-150.69 l 144.75,21.53 v -108.31 l -135.2,-15.46 v -113.4 l 72.64,8.31 71.61,54.68 c 69.61,53.17 165.49,55.62 237.74,6.1 3.93,7.18 7.44,14.57 10.51,22.16 l -275.09,275.08",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2843.66,2849.25 c -64.59,-26.2 -112.11,-82.59 -126.96,-150.69 l 144.75,21.53 v -108.31 l -135.2,-15.46 v -113.4 l 72.64,8.31 71.61,54.68 c 69.61,53.17 165.49,55.62 237.74,6.1 3.93,7.18 7.44,14.57 10.51,22.16 z",
    style: {
      fill: "none",
      stroke: "#050301",
      strokeWidth: 5.58411,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2378.19,3314.73 v -19.14 l -24.92,-82.3 c -70.88,-37.88 -155.98,-37.88 -226.86,0 l -24.92,82.3 v 186.43 h 109.41 l 167.29,-167.29",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2378.19,3314.73 v -19.14 l -24.92,-82.3 c -70.88,-37.88 -155.98,-37.88 -226.86,0 l -24.92,82.3 v 186.43 h 109.41 z",
    style: {
      fill: "none",
      stroke: "#050301",
      strokeWidth: 3.84309,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2210.9,3482.02 -163.5,163.5 h -60.03 l -8.36,-8.11 v -147.29 l 8.36,-8.1 h 223.53",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2210.9,3482.02 -163.5,163.5 h -60.03 l -8.36,-8.11 v -147.29 l 8.36,-8.1 z",
    style: {
      fill: "none",
      stroke: "#050301",
      strokeWidth: 3.22069,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2572.92,3645.52 163.51,-163.5 h 1289.91 l 8.35,8.1 v 147.29 l -8.35,8.11 H 2572.92",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2572.92,3645.52 163.51,-163.5 h 1289.91 l 8.35,8.1 v 147.29 l -8.35,8.11 z",
    style: {
      fill: "none",
      stroke: "#050301",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3912.22,3295.59 v 186.43 h -276.7 v -186.43 l 24.92,-82.3 c 70.87,-37.88 155.99,-37.88 226.86,0 l 24.92,82.3",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3912.22,3295.59 v 186.43 h -276.7 v -186.43 l 24.92,-82.3 c 70.87,-37.88 155.99,-37.88 226.86,0 z",
    style: {
      fill: "none",
      stroke: "#050301",
      strokeWidth: 3.84309,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2332.22,3886.23 177.81,-177.82 H 4036.7 v 322.65 c -17.43,78.15 -66.89,145.38 -136.3,185.28 l -226.23,718.22 c -445.78,62.67 -898.75,53.15 -1341.51,-28.2 l -217.33,-690.02 c -23.43,-13.47 -44.83,-30.19 -63.55,-49.67 l 98.12,-98.13 c 32.46,33.1 80.19,46.21 125.01,34.36 44.81,-11.85 79.81,-46.85 91.66,-91.66 11.85,-44.82 -1.26,-92.55 -34.35,-125.01",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2332.22,3886.23 177.81,-177.82 H 4036.7 v 322.65 c -17.43,78.15 -66.89,145.38 -136.3,185.28 l -226.23,718.22 c -445.78,62.67 -898.75,53.15 -1341.51,-28.2 l -217.33,-690.02 c -23.43,-13.47 -44.83,-30.19 -63.55,-49.67 l 98.12,-98.13 c 32.46,33.1 80.19,46.21 125.01,34.36 44.81,-11.85 79.81,-46.85 91.66,-91.66 11.85,-44.82 -1.26,-92.55 -34.35,-125.01 z",
    style: {
      fill: "none",
      stroke: "#050301",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3900.69,3978.27 c 0,71.2 -57.72,128.91 -128.93,128.91 -71.19,0 -128.91,-57.71 -128.91,-128.91 0,-71.2 57.72,-128.92 128.91,-128.92 71.21,0 128.93,57.72 128.93,128.92",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3900.69,3978.27 c 0,71.2 -57.72,128.91 -128.93,128.91 -71.19,0 -128.91,-57.71 -128.91,-128.91 0,-71.2 57.72,-128.92 128.91,-128.92 71.21,0 128.93,57.72 128.93,128.92 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3485.8,3846.88 v 192.17 c -313.38,81.78 -642.5,81.78 -955.88,0 v -192.17 h 955.88",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3485.8,3846.88 v 192.17 c -313.38,81.78 -642.5,81.78 -955.88,0 v -192.17 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3579.26,4729.64 122.82,-464.45 c -446.19,169.93 -938.33,175.31 -1388.12,15.15 l 134.77,435.13 c 374.91,50.08 754.49,54.83 1130.53,14.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3579.26,4729.64 122.82,-464.45 c -446.19,169.93 -938.33,175.31 -1388.12,15.15 l 134.77,435.13 c 374.91,50.08 754.49,54.83 1130.53,14.17 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2804.32,1976.28 c -36.11,0 -68.73,-21.54 -82.9,-54.76 l -8.94,-20.94 c -81.96,22.12 -151.55,76.35 -193.03,150.42 l 370.92,283.27 273.38,-357.99 h -359.43",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2804.32,1976.28 c -36.11,0 -68.73,-21.54 -82.9,-54.76 l -8.94,-20.94 c -81.96,22.12 -151.55,76.35 -193.03,150.42 l 370.92,283.27 273.38,-357.99 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2161.41,1450.42 78.14,230.37 c -126.55,18.33 -246.22,-62.8 -276.04,-187.15 -29.83,-124.34 40.02,-250.92 161.11,-292 121.1,-41.06 253.54,16.91 305.52,133.74 51.97,116.83 6.35,254.03 -105.23,316.47 l -78.14,-230.38 c -8,-23.57 -33.58,-36.2 -57.16,-28.2 -23.57,7.99 -36.19,33.58 -28.2,57.15",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2161.41,1450.42 78.14,230.37 c -126.55,18.33 -246.22,-62.8 -276.04,-187.15 -29.83,-124.34 40.02,-250.92 161.11,-292 121.1,-41.06 253.54,16.91 305.52,133.74 51.97,116.83 6.35,254.03 -105.23,316.47 l -78.14,-230.38 c -8,-23.57 -33.58,-36.2 -57.16,-28.2 -23.57,7.99 -36.19,33.58 -28.2,57.15 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7.07819,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3738.6,1323.27 h -267.58 c 50.95,-99.62 162.42,-152.62 271.86,-129.29 109.42,23.33 189.58,117.2 195.46,228.94 5.89,111.73 -63.94,213.52 -170.31,248.23 -106.37,34.7 -222.8,-6.3 -283.95,-100.01 h 254.52 c 57.08,-72.75 57.08,-175.1 0,-247.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3738.6,1323.27 h -267.58 c 50.95,-99.62 162.42,-152.62 271.86,-129.29 109.42,23.33 189.58,117.2 195.46,228.94 5.89,111.73 -63.94,213.52 -170.31,248.23 -106.37,34.7 -222.8,-6.3 -283.95,-100.01 h 254.52 c 57.08,-72.75 57.08,-175.1 0,-247.87 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 6.57251,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 500,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path-32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGjennomkjoringForbudt);
export default __webpack_public_path__ + "static/media/GjennomkjoringForbudt.1031a530a1cc4bc779c8c7b060641e0f.svg";
export { ForwardRef as ReactComponent };